import axios from 'axios'

/** Responses that will not change on retry: fail fast and let the page show its error state. */
const NO_RETRY_STATUSES = new Set([400, 401, 403, 404, 409, 422])
const MAX_RETRIES = 2

/**
 * TanStack Query `retry` option: retry network failures and 5xx a couple of times, never 4xx.
 * A 401 has already gone through the token-refresh flow in the axios interceptor by the time a
 * query sees it, so retrying again would only repeat a failed sign-in.
 */
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (failureCount >= MAX_RETRIES) return false
  if (axios.isCancel(error)) return false
  const status = axios.isAxiosError(error) ? error.response?.status : undefined
  if (status !== undefined && NO_RETRY_STATUSES.has(status)) return false
  if (status !== undefined && status < 500) return false
  return true
}
